import { render, staticRenderFns } from "./ChunkListItem.vue?vue&type=template&id=60909dfc&"
import script from "./ChunkListItem.vue?vue&type=script&lang=js&"
export * from "./ChunkListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60909dfc')) {
      api.createRecord('60909dfc', component.options)
    } else {
      api.reload('60909dfc', component.options)
    }
    module.hot.accept("./ChunkListItem.vue?vue&type=template&id=60909dfc&", function () {
      api.rerender('60909dfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/viewKnowledge/documents/components/ChunkListItem.vue"
export default component.exports